import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    authUser: {}
};
function userResource(data) {
    return {
        id: data.id,
        name: data.name,
        email: data.email,
        role: roleResource(data.role)
    };
}
function roleResource(data) {
    return {
        id: data.id,
        name: data.name
    };
}
export var AuthUserReducer = createSlice({
    name: 'authUser',
    initialState: initialState,
    reducers: {
        setAuthUser: function setAuthUser(state, payloadAction) {
            state.authUser = userResource(payloadAction.payload);
        }
    }
});
var setAuthUser = AuthUserReducer.actions.setAuthUser;
export { setAuthUser };
export default AuthUserReducer.reducer;
